import { BlockScrollStrategy } from '@angular/cdk/overlay';
import { ViewportRuler } from '@angular/cdk/scrolling';
import { ScrollService } from '@df/util/service/scroll.service';

export class ModalBlockScrollStrategy extends BlockScrollStrategy {
    unlock?: () => void;

    constructor(
        _viewportRuler: ViewportRuler,
        document: any,
        protected scrollService: ScrollService
    ) {
        super(_viewportRuler, document);
    }

    /** Blocks page-level scroll while the attached overlay is open. */
    override enable() {
        this.unlock = this.scrollService.blockScroll();
    }

    override disable(): void {
        if (this.unlock) {
            this.unlock();
        }

        this.unlock = undefined;
    }
}
